import "@perxis-auto/shared";
import "react";
import "../../../../features/filterValues/api/api.js";
import "../../../../features/filterValues/model/middleware/index.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import { selectAvailableFilterValuesQueries } from "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import { selectFilterImmutableQueries } from "../../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "react-router";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { selectPage } from "../../../../shared/store/installation/model/selectors/selectPage.js";
import "../../../../shared/store/installation/model/slice.js";
import { selectLimit } from "../../../../shared/store/pagination/model/selectors/selectLimit.js";
import "../../../../shared/store/pagination/model/slice.js";
import "../../../../features/filterChoice/model/middleware/index.js";
import "../../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import { selectFilterOptions } from "../../../../features/filterChoice/model/selectors/selectFilterOptions.js";
import "../../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../../features/filterChoice/model/slice.js";
import { FIELDS_GROUP_MAP } from "../../../../shared/config/fieldsGroup.js";
import "../../../../shared/store/config/middleware/index.js";
import { getConstructorFieldsValue } from "../../../../shared/store/config/lib/getConstructorFieldsValue.js";
import "../../../../shared/store/installation/middleware/index.js";
const selectVehiclesParameters = createAppSelector(
  [
    selectSlice,
    selectFilterOptions,
    selectFilterImmutableQueries,
    selectAvailableFilterValuesQueries,
    selectLimit,
    selectPage,
    (_, offset) => offset ?? 0
  ],
  (config, filterChoiceOptions, immutableQueries, queries, limit, page, offset) => {
    const { spaceId, envId } = config;
    const constructorFieldsValue = getConstructorFieldsValue(
      config,
      FIELDS_GROUP_MAP.VEHICLE_GET_VEHICLES,
      page.current
    );
    return {
      spaceId,
      envId,
      filter: {
        q: [...immutableQueries.q, ...queries.q]
      },
      options: {
        options: {
          ...filterChoiceOptions,
          fields: constructorFieldsValue == null ? void 0 : constructorFieldsValue.fields,
          offset,
          limit
        }
      },
      referenceFields: constructorFieldsValue == null ? void 0 : constructorFieldsValue.referenceFields
    };
  }
);
export {
  selectVehiclesParameters
};
